<template>
    <div >
        <div class="bg-image" >
            <div class="bg-body-light">
                <div class="flex-column p-2 content-full">
                    <div class="d-flex justify-content-between align-items-center">
                        <h1 class="flex-fill font-size-h2 my-2">
                            <i class="fa fa-boxes  mr-1"></i> All Projects
                        </h1>
                        <a v-if="user && user.projectCount < 2 || $hasRole('admin') || $hasRole('reseller')" class="btn btn-success my-2" @click.prevent="createProject" href="">
                            <i class="fa fa-fw fa-plus"></i><span class="d-none d-sm-inline ml-1"> New Project</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-auto">
            <projects></projects>
        </div>
    </div>
</template>

<script>
    //import {mapGetters, mapState} from 'vuex';
    import Projects from '../projects/Projects';

    export default {
        name: "Landing",
        components: {
            'projects': Projects,
        },
        data(){
            return {
            }
        },
        // computed:{
        //     ...mapState({user: 'authenticatedUser'})
        // },
        methods: {
            createProject() {
                this.$router.push('/projects/create')
            }
        }
    }
</script>

<style scoped>

</style>
